import { Ref, SetStateAction } from 'react'

export interface DateTimePickerState {
  value: Partial<{
    day: number
    month: number
    year: number
    time: string
  }>
  datePicker: {
    month: number
    year: number
  }
  isExpanded: boolean
  isLoading: boolean
  isProlongation: boolean
  visibleSection: VisibleSectionEnum | undefined
  props: Partial<DateTimePickerProps>
}
export interface DateTimePickerProps {
  title: string
  isPickup: boolean
  isProlongation: boolean
  defaultIsLoading?: boolean
  defaultCollapsed?: boolean
  defaultDate?: Date | null
  defaultTime?: string | null
  defaultVisibleSection?: VisibleSectionEnum
  disabled?: boolean
  /**
   * Whether date should be disabled. Dates before `minDate` and after `maxDate` will be disabled automatically
   */
  shouldDisableDate?: DateTimePickerDatePredicate
  /**
   * Whether hour should be disabled
   */
  shouldDisableHour?: DateTimePickerHourPredicate
  /**
   * Whether date button should be disabled
   */
  shouldDisableDateButton?: DateTimePickerButtonPredicate
  /**
   * Whether time button should be disabled
   */
  shouldDisableTimeButton?: DateTimePickerButtonPredicate
  /**
   * Event fired when valid date and time is selected
   */
  onChange?: DateTimePickerChangeHandler
  /**
   * Event fired when user clicks an arrow changing displayed month
   */
  onDisplayedMonthChange?: DateTimePickerDisplayedMonthChangeHandler
}

export type DateTimePickerChangeHandler = (value: Required<DateTimePickerState['value']>) => void
export type DateTimePickerDisplayedMonthChangeHandler = (newMonth: number, state: DateTimePickerState) => void
export type DateTimePickerDatePredicate = (date: Date) => boolean
export type DateTimePickerHourPredicate = (hour: string, date: Date) => boolean
export type DateTimePickerButtonPredicate = (state: DateTimePickerState) => boolean
export type LocationPickerPredicate = (selectedLocationId: number | undefined) => void
export type RegionLocationPickerPredicate = (
  selectedRegionId: number | undefined,
  selectedLocationId: number | undefined,
) => void
export type AmountChangePredicate = (amount: number) => void
export type CheckPeriodPredicate = (locationId: number | undefined) => boolean
export type CheckIfRerentPredicate = (locationId: number | undefined) => boolean

export interface DateTimePickerHandle {
  collapse: VoidFunction
  expand: VoidFunction
  reset: VoidFunction
  hideLoader: VoidFunction
  displayLoader: VoidFunction
  changeDisplayedMonth: (newMonth: number, newYear: number) => void
  changeVisibleSection: (newSection: VisibleSectionEnum) => void
}

export enum VisibleSectionEnum {
  DATE = 'date',
  TIME = 'time',
}

export interface DateTimePickerContextType {
  dateTimeState: DateTimePickerState
  setDateTimeState: (s: SetStateAction<DateTimePickerState>) => void
}

export type UseDateTimePickerHook = (
  props: DateTimePickerProps,
  ref: Ref<DateTimePickerHandle>,
) => [DateTimePickerState, React.Dispatch<React.SetStateAction<DateTimePickerState>>]
